import React from 'react';
import PropTypes from 'prop-types';

import './index.scss';

/**
 * @todo change color of icon svg
 */

export default function Button({ children, disabled, ghost, onClick, type, iconSrc }) {
  const ghostClassName = ghost && !disabled ? 'Button--ghost' : '';

  return (
    <button
      type="button"
      className={`Button Button--${type} ${ghostClassName}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
      {iconSrc && <img className="Button__icon" alt="icon" src={iconSrc} />}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  ghost: PropTypes.bool,
  iconSrc: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  type: PropTypes.oneOf(['regular', 'primary', 'success', 'danger', 'warn', 'gold']),
};

Button.defaultProps = {
  disabled: false,
  ghost: false,
  iconSrc: null,
  type: 'regular',
};
